<template>
  <table>
    <tr>
      <th v-for="(name, index) in header" :key="index" v-html="(labels !== undefined && labels[name] !== undefined)? labels[name]: name"/>
    </tr>
    <row v-for="(item, index) in items" :key=index :item="item" :undisplayed="undisplayed" :transform="transform" />
  </table>
</template>
<script>
import row from '@/components/row'

export default {
  name: 'array',
  props: ['items', 'undisplayed', 'transform', 'labels'],
  components: {
    row
  },
  computed: {
    header () {
      if (this.items.length) {
        const header = Object.getOwnPropertyNames(this.items[0])
        return header.filter(item => item !== '__ob__' && this.undisplayed.indexOf(item) < 0)
      }
      return []
    }
  }
}
</script>
